<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6">
            <v-card class="elevation-0">
              <v-card-text>
              <h1>{{ errorTitle }}</h1>
                <v-divider class="my-5"></v-divider>
                <v-btn href="/" elevation="0" color="success">Go to main page</v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    </v-app>
</template>

<script>
  import { required, email } from "vuelidate/lib/validators";
  import { mapFields } from 'vuex-map-fields';
  export default {
    data: () => ({

    }),
    computed:{
      errorTitle(){
        let text = 'Unknown error';
        switch(this.$route.name){
          case 'i18n-error':
            text = "Fatal error on loading localization";
            break;
        }

        return text;
      }
    },
    methods: {

    },
  }
</script>